import { makeAutoObservable } from "mobx";
import { Step } from "../steps/v2/step";
import { EventEmitter } from "@/lib/events/eventEmitter";
import { TourPlayback } from "@common/schemas/v2/tour";
import { TourEngagedManagerEvents, TourEngagedManagerNamespace } from "./tourEngagedManager.events";
import { QuestionChoice, ModalChoice } from "@common/models";

export class TourEngagedManager {
  private currentStep?: Step;
  private stopListenStepEvents?: () => void;
  private tourPlayback: TourPlayback;
  private hasEmittedEngaged = false;

  events = new EventEmitter<typeof TourEngagedManagerNamespace, TourEngagedManagerEvents, any>(
    TourEngagedManagerNamespace
  );

  constructor(tourPlayback: TourPlayback) {
    this.tourPlayback = tourPlayback;

    makeAutoObservable(this);
  }

  setCurrentStep(step: Step) {
    if (this.currentStep?.id === step.id) return;

    this.clearCurrentStep();
    this.currentStep = step;
    this.checkEngagement();
  }

  private checkEngagement() {
    if (this.hasEmittedEngaged) return;

    const steps = this.tourPlayback.sections.flatMap((section) => section.steps);
    const currentStepIndex = steps.findIndex((s) => s.id === this.currentStep?.id);

    if (currentStepIndex === -1) return;

    // Count non-redirect steps up to current step
    const nonRedirectStepsCount = steps
      .slice(0, currentStepIndex + 1)
      .filter((step) => step.attributes.type !== "redirect").length;

    if (nonRedirectStepsCount >= 2) {
      this.hasEmittedEngaged = true;
      this.events.emit("engaged", {});
    }
  }

  clearCurrentStep() {
    this.stopListenStepEvents?.();
    this.currentStep = undefined;
  }

  stop() {
    this.stopListenStepEvents?.();
    this.hasEmittedEngaged = false;
  }
}
